import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useTranslation } from 'react-i18next'
import FormTextField from './FormTextField'
import { DATE_TIME_FORMAT } from '@/libs/core/constants'

const FormDateTimePicker = ({ formProps, inputConfig, itemProps }) => {
  const { t } = useTranslation()

  const { label, disabled } = itemProps || {}

  const { mindate, minDateTime, maxdate, maxDateTime, ...otherItemProps } = itemProps || {}
  const { field: { ref, onChange, ...fieldProps } = {} } = formProps || {}

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DateTimePicker
        disabled={disabled}
        label={label}
        onChange={value => {
          onChange(value?.toDate())
        }}
        inputRef={ref}
        mindate={mindate}
        minDateTime={minDateTime}
        maxdate={maxdate}
        maxDateTime={maxDateTime}
        {...fieldProps}
        inputFormat={DATE_TIME_FORMAT}
        renderInput={params => {
          const { InputProps, inputProps, inputRef } = params
          return (
            <FormTextField
              InputProps={InputProps}
              inputRef={inputRef}
              inputProps={{
                ...inputProps,
                placeholder: t('format.date'),
              }}
              itemProps={otherItemProps}
              formProps={formProps}
              inputConfig={{ sx: { width: 200 }, ...inputConfig }}
            />
          )
        }}
      />
    </LocalizationProvider>
  )
}

export default FormDateTimePicker
